import { Link } from 'react-router-dom';
import { categories, categoryColorMap } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            内容分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            八大内容分类，精准覆盖亚洲各地区与主题，助您快速找到感兴趣的内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((category) => {
            const colors = categoryColorMap[category.color];
            return (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className={`group relative p-4 md:p-5 rounded-lg ${colors.bg} ${colors.border} border transition-all duration-300 hover:scale-[1.02]`}
              >
                <div className="flex flex-col items-center text-center gap-3">
                  <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center ${colors.badge} bg-opacity-90 text-white group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${category.icon} text-xl md:text-2xl`}></i>
                  </div>
                  <div>
                    <h3 className={`font-heading text-sm md:text-base font-semibold ${colors.text} mb-1`}>
                      {category.name}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                      {category.description}
                    </p>
                  </div>
                  <span className={`text-xs px-2.5 py-0.5 rounded-full ${colors.bg} ${colors.text} font-medium`}>
                    {category.count} 篇文章
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}